window.EM = window.EM || {};
window.EM.booking = window.EM.booking || {};

(function (ns) {
  var st = ns.state;

  function getLocationByVenueId(venueId) {
    var found = null;
    $.each(locations, function (locationId, location) {
      if (location.venueId === venueId) {
        found = location;
        return false;
      }
    });
    return found;
  }

  function getRoomByEventId(venueId, eventId) {
    var found = null;
    $.each(locations, function (locationId, location) {
      if (location.venueId !== venueId) return;
      $.each(location.rooms, function (roomId, room) {
        if ($.inArray(eventId, room.eventIds) > -1) {
          found = room;
          return false;
        }
      });
      if (found !== null) return false;
      $.each(location.tables, function (tableId, table) {
        if ($.inArray(eventId, table.eventIds) > -1) {
          found = table;
          return false;
        }
      });
      return false;
    });
    return found;
  }

  function getSelectedTimeSlot() {
    var state = st.get();
    var allDates = st.getAllDates();
    var timeSlot = {
      location: null,
      event: null,
      data: null,
    };

    var events = allDates[state.date];
    $.each(events, function (eventIndex, event) {
      if (state.event !== null && $.inArray(state.event, event.room.eventIds) > -1 && event.venue.id == state.venue) {
        timeSlot.event = event;

        if (typeof timeSlot.event.eventPrices !== "undefined") {
          timeSlot.event = $.extend(true, {}, timeSlot.event, {
            prices: timeSlot.event.eventPrices.find(function (ep) {
              return ep.eventId === state.event;
            }),
          });
        }

        $.each(event.times, function (dayIndex, day) {
          $.each(day.slots, function (slotIndex, slot) {
            if (slot.time == state.time) {
              timeSlot.data = slot;
              return false;
            }
          });
          if (timeSlot.data !== null) {
            return false;
          }
        });

        return false;
      }
    });

    timeSlot.location = getLocationByVenueId(state.venue);
    timeSlot.room = getRoomByEventId(state.venue, state.event);

    return timeSlot.event === null ? null : timeSlot;
  }

  function getBookings(opt) {
    var deferred = $.Deferred();
    var allDates = st.getAllDates();
    var url = "/api/booking/get?start=" + opt.start + "&end=" + (opt.end || opt.start);

    if (opt.venue) {
      url += "&venue=" + opt.venue;
    }
    if (opt.order) {
      url += "&order=" + opt.order;
    }

    if (opt.useCache && Object.keys(allDates).length > 0) {
      return deferred.resolve(allDates).promise();
    }

    $.get(url)
      .done(function (response) {
        if (!response.success) {
          return deferred.reject(response.message);
        }
        st.mergeDates(response.data);
        if (response.header) {
          $(".booking-header").html(response.header);
        }
        deferred.resolve(response.data);
      })
      .fail(function () {
        return deferred.reject();
      });

    return deferred.promise();
  }

  ns.data = {
    getLocationByVenueId: getLocationByVenueId,
    getRoomByEventId: getRoomByEventId,
    getSelectedTimeSlot: getSelectedTimeSlot,
    getBookings: getBookings,
  };
})(window.EM.booking);
